import { AdvancedImage } from '@cloudinary/react'
import { Cloudinary } from '@cloudinary/url-gen'
import { fill, thumbnail } from '@cloudinary/url-gen/actions/resize'
import { FocusOn } from '@cloudinary/url-gen/qualifiers/focusOn'
import { focusOn } from '@cloudinary/url-gen/qualifiers/gravity'
import classNames from 'classnames'

interface RemoteImageProps {
  heroImagePublicId: string
  alt: string
  className?: string
  shouldFillImage?: boolean
  round?: boolean
}

const RemoteImage: React.FC<React.PropsWithChildren<RemoteImageProps>> = ({
  heroImagePublicId,
  alt,
  round = true,
  className = 'h-48 w-48',
  shouldFillImage = true,
}) => {
  const cloudinary = new Cloudinary({
    cloud: {
      cloudName: process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME,
    },
  })

  const classes = classNames(
    'inline-block',
    {
      'rounded-full': round,
      'rounded-lg': !round,
    },
    className,
  )

  const cloudinaryImage = shouldFillImage
    ? cloudinary.image(heroImagePublicId).resize(thumbnail().width(600).height(600).gravity(focusOn(FocusOn.faces())))
    : cloudinary.image(heroImagePublicId).resize(fill().width(300).height(200).gravity(focusOn(FocusOn.faces())))

  return <AdvancedImage className={classes} cldImg={cloudinaryImage} alt={alt} />
}

export default RemoteImage
